/**
 * @providesModule BalanceSplitComponent
 */

import {SKZUserInterface} from 'SKZUser';
import styles from './BalanceSplitComponent.style';
import {View} from 'react-native';
import I18n from 'INTL';
import Label from 'Label';

const ChildCell = (cellText: string, value: string) => {
  return (
    <View style={styles.balanceCellContainer}>
      <Label style={styles.normalGreyText}>{cellText}</Label>
      <Label style={styles.boldTextH4}>{value}</Label>
    </View>
  );
};
const HeaderCell = (cellText: string, value: string) => {
  return (
    <View style={styles.balanceCellContainer}>
      <Label style={styles.boldText}>{cellText}</Label>
      <Label style={styles.totalBalanceValue}>{value}</Label>
    </View>
  );
};
const BalanceSplitComponent = ({
  userInfo,
  removeBackground,
}: {
  userInfo: SKZUserInterface | null | undefined;
  removeBackground?: boolean;
}) => {
  return (
    <View
      style={[
        styles.balanceSplitContainer,
        removeBackground ? {backgroundColor: 'white', borderRadius: 10} : {},
      ]}
    >
      {HeaderCell(
        I18n.message('TOTAL BALANCE:'),
        I18n.getCurrencyString(userInfo?.cash_balance ?? 0, I18n.currencySymbol())
      )}
      <View style={styles.divider} />
      {ChildCell(
        I18n.message('Cash:'),
        I18n.getCurrencyString(userInfo?.real_cash_balance ?? 0, I18n.currencySymbol())
      )}
      <View style={styles.divider} />
      {ChildCell(
        I18n.message('Bonus Cash:'),
        I18n.getCurrencyString(userInfo?.bonus_balance ?? 0, I18n.currencySymbol())
      )}
    </View>
  );
};
export default BalanceSplitComponent;
